import React, { useState } from 'react'
import Notice from '../common/notice/Notice'
import { performRequest } from '../common/utils'

const Tools = () => {
    const [isRequested, setIsRequested] = useState([])
    const [notice, setNotice] = useState()
    
    const recalculate = async( action, nonce ) => {
        if( isRequested.includes( action ) ) return

        try {
            const formData = new FormData()
            formData.append('action', action)
            formData.append('nonce', nonce)
            const request = await performRequest(recalculate_object.ajaxurl, formData)
            const res = await request.json()

            if( !res.success ){
                return setNotice({
                    type:'error',
                    message: res.errors.shift()
                })
            } 

            setNotice({
                type:'success',
                message: res.message
            })
        } catch (error) {
            console.error(error)
        }
    }

    return (
        <>  
            {/* { notice && <Notice notice={ notice } /> }
            <div className="setting-row">
                <h3>Recalculate Courses in team-synced LearnDash Groups</h3>
                <p> When encountering issues with user course access, utilize this button to initiate the repair process.</p>
                <a href="#" className="button button-outline-primary" onClick={()=>recalculate('recalculate_courses', recalculate_object.nonce_courses)}>Recalculate LD Group Courses</a>
            </div> */}
            {/* 
            //TODO: commented it for now since it's not done yet. It's not priority.
            <div className="tangible-card">
                <div className="card-title">
                    <h3>Recalculate Group access granted by Memberships</h3>
                    <p> When encountering issues with user course access, utilize this button to initiate the repair process.</p>
                    <a href="#" className="button button-outline-primary" onClick={()=>recalculate('recalculate_group_access',recalculate_object.nonce_group_access)}>Recalculate LD Group Access</a>
                </div>
            </div> */}
        </>
    )
}

export default Tools